export interface ScheduleState {
    schedules: Array<Schedule>;
    selected: Schedule;
    initState: string;
    sortDirection: boolean;
}

export interface Schedule {
    id: string;
    name: string;
    monday: [TimeRange?];
    tuesday: [TimeRange?];
    wednesday: [TimeRange?];
    thursday: [TimeRange?];
    friday: [TimeRange?];
    saturday: [TimeRange?];
    sunday: [TimeRange?];
    exceptions: [TimeRange?];
}

export interface TimeRange {
    start: string;
    end: string;
}

const defaultSchedule = {
    id: undefined,
    name: undefined,
    monday: [],
    tuesday: [],
    wednesday: [],
    thursday: [],
    friday: [],
    saturday: [],
    sunday: [],
    exceptions: [],
};

export default {
    namespaced: true,
    state: (): ScheduleState => ({
        schedules: [],
        selected: undefined,
        initState: undefined,
        sortDirection: false,
    }),
    getters: {
        editState(state, getters) {
            if (!state.initState || !getters.selected || !getters.selected.id) return false;
            return state.initState != JSON.stringify(getters.selected);
        },
        selected(state) {
            if (!state.selected) return defaultSchedule;
            return state.schedules.find((schedule) => schedule.id == state.selected) || defaultSchedule;
        },
    },
    mutations: {
        setSchedules(state, value) {
            state.schedules = value;
            const selected = value.find((schedule) => schedule.id == state.selected);
            if (selected) state.initState = JSON.stringify(selected);
        },
        sortSchedule(state) {
            state.schedules.sort((a, b) => {
                if (a.name == "Neuer Zeitplan") return -1;
                if (b.name == "Neuer Zeitplan") return 1;
                if (a.name < b.name) return 1;
                if (a.name > b.name) return -1;
                return 0;
            });
            if (!state.sortDirection) state.schedules.reverse();
        },
        reverseSortDirection(state) {
            state.sortDirection = !state.sortDirection;
        },
        selectSchedule(state, selected) {
            if (state.initState && state.selected) {
                const index = state.schedules.findIndex((schedule) => schedule.id == state.selected);
                state.schedules[index] = JSON.parse(state.initState);
                state.schedules = [...state.schedules];
            }

            state.selected = selected;

            const schedule = state.schedules.find((schedule) => schedule.id == state.selected);
            if (schedule) state.initState = JSON.stringify(schedule);
            else state.initState = undefined;
        },
        resetSchedule(state) {
            if (state.initState && state.selected) {
                const index = state.schedules.findIndex((schedule) => schedule.id == state.selected);
                state.schedules[index] = JSON.parse(state.initState);
                state.schedules = [...state.schedules];
            }
        },
    },
    actions: {
        fetchSchedules(state) {
            this._vm.axios
                .get("/schedule")
                .then((res) => state.commit("setSchedules", res.data))
                .catch(() =>
                    state.commit("ui/logMessage", { logLevel: 0, message: "Die Schedule Daten konnten nicht geladen werden." }, { root: true })
                );
        },
        createSchedule(state) {
            this._vm.axios
                .post("/schedule", { name: "Neuer Zeitplan" })
                .then((res) => state.commit("selectSchedule", res.data.schedule_id))
                .then(() => state.commit("ui/logMessage", { logLevel: 4, message: "Ein neuer Zeitplan wurde erstellt" }, { root: true }))
                .then(() => state.dispatch("fetchSchedules"))
                .catch(() => state.commit("ui/logMessage", { logLevel: 0, message: "Der Zeitplan konnte nicht erstellt werden" }, { root: true }));
        },
        saveSchedule(state, schedule) {
            this._vm.axios
                .put("/schedule/" + schedule.id, schedule)
                .then(() => state.commit("ui/logMessage", { logLevel: 4, message: "Der Zeitplan wurde gespeichert" }, { root: true }))
                .then(() => state.dispatch("fetchSchedules"))
                .catch(() => state.commit("ui/logMessage", { logLevel: 0, message: "Der Zeitplan konnte nicht gespeichert werden" }, { root: true }));
        },
        removeSchedule(state, schedule) {
            this._vm.axios
                .delete("/schedule/" + schedule.id)
                .then(() => state.commit("ui/logMessage", { logLevel: 4, message: "Der Zeitplan wurde gelöscht" }, { root: true }))
                .then(() => state.dispatch("fetchSchedules"))
                .catch(() => state.commit("ui/logMessage", { logLevel: 0, message: "Der Zeitplan konnte nicht gelöscht werden" }, { root: true }));
        },
    },
};
